import React, { useEffect, useState, useRef } from "react";
import { motion } from "framer-motion";
import { MdClose, MdRefresh } from "react-icons/md";
import * as XLSX from "xlsx";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MdFilterList } from "react-icons/md";
import DatePicker from "react-datepicker";

const CallHistory = ({ user }) => {
  const [callData, setCallData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage] = useState(5);
  const [selectedCall, setSelectedCall] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedSentiment, setSelectedSentiment] = useState("");
  const [updating, setUpdating] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [comment, setComment] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [users, setUsers] = useState([]);
  const [userDropdownOpen, setUserDropdownOpen] = useState(false);
  const [isFilterDropdownOpen, setIsFilterDropdownOpen] = useState(false);
  const filterDropdownRef = useRef(null);
  const [selectedSentiments, setSelectedSentiments] = useState([]);




  const today = new Date();
  const last30Days = new Date();
  last30Days.setDate(today.getDate() - 30);

  const [startDate, setStartDate] = useState(last30Days);
  const [endDate, setEndDate] = useState(today);
  const [tempStart, setTempStart] = useState(startDate);
  const [tempEnd, setTempEnd] = useState(endDate);
  const [isOpen, setIsOpen] = useState(false);
  const datePickerRef = useRef(null);



  const sentiments = ["Positive", "Negative", "Neutral", "Negative/DND", "Not Attended"];

  // added the handle outside fuction but not working have to chek  
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if click is outside the filter dropdown
      if (
        filterDropdownRef.current &&
        !filterDropdownRef.current.contains(event.target)
      ) {
        setIsFilterDropdownOpen(false);
      }
      // Check if click is outside the date picker
      if (
        datePickerRef.current &&
        !datePickerRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup event listener on unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);




  // const filteredData = callData.filter((call) => {
  //   const matchesSearch =
  //     (call.from?.toLowerCase() || "").includes(search.toLowerCase()) ||
  //     (call.to?.toLowerCase() || "").includes(search.toLowerCase()) ||
  //     (call.recordingUrl?.toLowerCase() || "").includes(search.toLowerCase());

  //   const callDate = new Date(call.createdAt);
  //   const callDateOnly = new Date(callDate.getFullYear(), callDate.getMonth(), callDate.getDate());

  //   // Check if startDate and endDate are valid dates before using them
  //   const fromDateOnly = startDate ? new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate()) : null;
  //   const toDateOnly = endDate ? new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate()) : null;

  //   // If startDate and endDate are provided, filter by date range
  //   // const matchesDate = fromDateOnly && toDateOnly
  //   //   ? callDateOnly >= fromDateOnly && callDateOnly <= toDateOnly
  //   //   : true; // If no date range, include all calls

  //   const matchesDate = fromDateOnly && toDateOnly
  //     ? callDateOnly >= fromDateOnly && callDateOnly <= new Date(toDateOnly.getFullYear(), toDateOnly.getMonth(), toDateOnly.getDate(), 23, 59, 59)
  //     : true;


  // const matchesSentiment =
  //   selectedSentiments.length === 0 ||
  //   (selectedSentiments.includes("Negative/DND") && !call.agentSentiment) ||
  //   selectedSentiments.includes(call.agentSentiment);

  // return matchesSearch && matchesDate && matchesSentiment;
  // });




  // const getStartOfMonth = () => {
  //   const now = new Date();
  //   // Use UTC to avoid timezone issues
  //   return new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1))
  //     .toISOString()
  //     .split("T")[0];
  // };

  // const [fromDate, setFromDate] = useState(getStartOfMonth());
  // const [toDate, setToDate] = useState("");
  const [selectedUserId, setSelectedUserId] = useState("");


  useEffect(() => {
    console.log("useEffect triggered, user:", user); // Log when useEffect runs

    if (!user || !user.id || !user.role) {
      setError("User information is missing. Please log in again.");
      setLoading(false);
      return;
    }

    fetchCallHistory();
    fetchUsers();
  }, [user]);


  const fetchUsers = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_API}/api/users`);
      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
      const data = await response.json();
      setUsers(data);
      console.log("Fetched users:", data); // Debug log
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };



  const fetchCallHistory = async () => {
    console.log("Fetching call history...");
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_API}/api/call-history?userId=${user.id}&role=${user.role}`);
      console.log("Fetch response:", response);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      let data = await response.json();
      console.log("Raw call history data:", data);
      console.log("Logged-in user:", user);

      setCallData(data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching call history:", error);
      setError("Failed to load call history. Please try again.");
      setLoading(false);
    }
  };


  const handleRefresh = () => {
    setLoading(true);
    setError(null);
    setSearch("");
    setCurrentPage(1);
    setSelectedSentiments([]);
    setSelectedDate("");
    setSelectedUserId("");
    const newStart = new Date();
    newStart.setDate(today.getDate() - 30);
    const newEnd = new Date(today);
    setStartDate(newStart);
    setEndDate(newEnd);
    setTempStart(newStart);
    setTempEnd(newEnd);
    setCallData([]);
    setUsers([]);
    fetchCallHistory();
    fetchUsers();
  };


  function formatDateToDDMMYYYY(dateString) {
    const date = new Date(dateString);
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();
    return `${day}/${month}/${year}`;
  }


  const getUserNameById = (userId) => {

    const foundUser = users.find((u) => u._id === userId || u.id === userId);
    console.log("Looking for userId:", userId, "Found user:", foundUser);
    return foundUser ? foundUser.name : "Unknown";
  };

  const filteredData = callData.filter((call) => {
    const matchesSearch =
      (call.from?.toLowerCase() || "").includes(search.toLowerCase()) ||
      (call.to?.toLowerCase() || "").includes(search.toLowerCase()) ||
      (call.recordingUrl?.toLowerCase() || "").includes(search.toLowerCase());

    const matchesSentiment =
      selectedSentiments.length === 0 ||
      (selectedSentiments.includes("Not Attended") && !call.agentSentiment) ||
      selectedSentiments.includes(call.agentSentiment);



    // const callDate = new Date(call.createdAt);
    // const today = new Date();
    // const from = fromDate ? new Date(fromDate) : new Date(getStartOfMonth());
    const callDate = new Date(call.createdAt);
    const callDateOnly = new Date(callDate.getFullYear(), callDate.getMonth(), callDate.getDate());

    // Check if startDate and endDate are valid dates before using them
    const fromDateOnly = startDate ? new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate()) : null;
    const toDateOnly = endDate ? new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate()) : null;
    const matchesUser = !selectedUserId || call.userId === selectedUserId;
    // If startDate and endDate are provided, filter by date range
    // const matchesDate = fromDateOnly && toDateOnly
    //   ? callDateOnly >= fromDateOnly && callDateOnly <= toDateOnly
    //   : true; // If no date range, include all calls

    const matchesDate = fromDateOnly && toDateOnly
      ? callDateOnly >= fromDateOnly && callDateOnly <= new Date(toDateOnly.getFullYear(), toDateOnly.getMonth(), toDateOnly.getDate(), 23, 59, 59)
      : true;

    // return matchesSearch && matchesDate && matchesUser;

    return matchesSearch && matchesDate && matchesSentiment && matchesUser;
    // from here i am removing  matchesUser from here temporary
  });


  const formattedDateRange = startDate && endDate
    ? `${startDate.toLocaleDateString("en-US", { month: "short", day: "2-digit" })} - 
       ${endDate.toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" })}`
    : "Select Date Range";

  const applyDateRange = () => {
    setStartDate(tempStart);
    setEndDate(tempEnd);
    setIsOpen(false);
  };


  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredData.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const openSummaryPopup = (call) => {
    setSelectedCall(call);
    setSelectedSentiment(call.qaStatus);
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setSelectedCall(null);
    setSelectedSentiment("");
  };

  const handleUpdate = () => {
    if (!selectedCall) return;

    if (!selectedSentiment) {
      toast.warn("Please select a sentiment.", { autoClose: 2000 });
      return;
    }

    if (!comment.trim()) {
      toast.warn("Please leave a comment.", { autoClose: 2000 });
      return;
    }

    setUpdating(true);
    fetch(
      `${process.env.REACT_APP_SERVER_API}/api/call-history/${selectedCall._id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          qaStatus: selectedSentiment,
          comments: comment,
        }),
      }
    )
      .then((response) => {
        if (!response.ok)
          throw new Error("Failed to update sentiment and comment.");
        return response.json();
      })
      .then((updatedCall) => {
        setCallData((prevData) =>
          prevData.map((call) =>
            call._id === updatedCall._id ? updatedCall : call
          )
        );
        toast.success("Sentiment and comment updated successfully!", {
          autoClose: 2000,
        });
      })
      .catch((error) => {
        console.error("Error updating sentiment and comment:", error);
        toast.error("Failed to update sentiment and comment. Please try again.", {
          autoClose: 2000,
        });
      })
      .finally(() => setUpdating(false));
  };
  const exportToCSV = () => {
    const headers = [
      "ID",
      "From",
      "To",
      "Start Time",
      "End Time",
      "Sentiment Status",
      "Updated Status",
      "Updated Comments",
      "Recording URL",
      "Transcription",
    ];
  
    // Function to parse time like "01:05:11 pm" and combine with createdAt date
    const formatDate = (timeStr, createdAt) => {
      try {
        if (!timeStr || !createdAt) return "N/A";
  
        // Parse the time string (e.g., "01:05:11 pm")
        const timeRegex = /^(\d{1,2}):(\d{2}):(\d{2})\s*(am|pm)$/i;
        const match = timeStr.match(timeRegex);
        if (!match) return "N/A";
  
        const [, hoursStr, minutes, seconds, period] = match;
        let hours = parseInt(hoursStr, 10);
        if (period.toLowerCase() === "pm" && hours !== 12) hours += 12;
        if (period.toLowerCase() === "am" && hours === 12) hours = 0;
  
        // Get the date from createdAt (e.g., "2025-03-17")
        const baseDate = new Date(createdAt);
        if (isNaN(baseDate.getTime())) return "N/A";
  
        // Create a new Date with the parsed time on the createdAt date
        const date = new Date(
          baseDate.getFullYear(),
          baseDate.getMonth(),
          baseDate.getDate(),
          hours,
          parseInt(minutes, 10),
          parseInt(seconds, 10)
        );
  
        if (isNaN(date.getTime())) return "N/A";
  
        // Format to YYYY-MM-DD HH:MM:SS
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");
        const formattedHours = date.getHours().toString().padStart(2, "0");
        const formattedMinutes = date.getMinutes().toString().padStart(2, "0");
        const formattedSeconds = date.getSeconds().toString().padStart(2, "0");
  
        return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
      } catch (e) {
        return "N/A";
      }
    };
  
    const data = filteredData.map((call, index) => [
      index + 1,
      call.from || "N/A",
      call.to || "N/A",
      formatDate(call.startTime, call.createdAt), // Parse and format startTime
      formatDate(call.endTime, call.createdAt), // Parse and format endTime
      call.agentSentiment,
      call.qaStatus,
      call.comments || "N/A",
      call?.recordingUrl || "N/A",
      `"${(call.diarization && call.diarization.map(d => `${d.speaker}: ${d.text}`).join('   |   ')) || ''}"`,
    ]);
  
    const csvContent = [headers, ...data]
      .map((row) => row.map((cell) => `"${cell}"`).join(","))
      .join("\n");
  
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "call_history.csv";
    link.click();
  };

 // XLSX Export (updated)
const exportToXLSX = () => {
  // Reusing the same formatDate function for consistency
  const formatDate = (timeStr, createdAt) => {
    try {
      if (!timeStr || !createdAt) return "N/A";

      // Parse the time string (e.g., "01:05:11 pm")
      const timeRegex = /^(\d{1,2}):(\d{2}):(\d{2})\s*(am|pm)$/i;
      const match = timeStr.match(timeRegex);
      if (!match) return "N/A";

      const [, hoursStr, minutes, seconds, period] = match;
      let hours = parseInt(hoursStr, 10);
      if (period.toLowerCase() === "pm" && hours !== 12) hours += 12;
      if (period.toLowerCase() === "am" && hours === 12) hours = 0;

      // Get the date from createdAt (e.g., "2025-03-17")
      const baseDate = new Date(createdAt);
      if (isNaN(baseDate.getTime())) return "N/A";

      // Create a new Date with the parsed time on the createdAt date
      const date = new Date(
        baseDate.getFullYear(),
        baseDate.getMonth(),
        baseDate.getDate(),
        hours,
        parseInt(minutes, 10),
        parseInt(seconds, 10)
      );

      if (isNaN(date.getTime())) return "N/A";

      // Format to YYYY-MM-DD HH:MM:SS

      const formattedHours = date.getHours().toString().padStart(2, "0");
      const formattedMinutes = date.getMinutes().toString().padStart(2, "0");
      const formattedSeconds = date.getSeconds().toString().padStart(2, "0");

      return ` ${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
    } catch (e) {
      return "N/A";
    }
  };

  const sheetData = filteredData.map((call, index) => ({
    ID: index + 1,
    From: call.from || "N/A",
    To: call.to || "N/A",
    "Start Time": formatDate(call.startTime, call.createdAt), // Use string instead of Date
    "End Time": formatDate(call.endTime, call.createdAt), // Use string instead of Date
    "Sentiment Status": call.agentSentiment || "N/A",
    "Updated Status": call.qaStatus || "N/A",
    "Updated Comments": call.comments || "N/A",
    "Recording URL": call.recordingUrl || "N/A",
    Transcription:
      (call.diarization &&
        call.diarization.map((d) => `${d.speaker}: ${d.text}`).join("   |   ")) ||
      "N/A",
  }));

  const worksheet = XLSX.utils.json_to_sheet(sheetData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Call History");

  XLSX.writeFile(workbook, "call_history.xlsx");
};

  return (
    <div className="p-6 overflow-y-scroll h-screen bg-gray-50">
      <ToastContainer />
      {/* Header */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="flex justify-between items-center mb-6"
      >
        <h1 className="text-3xl font-bold text-gray-900">Call History</h1>

      </motion.div>

      {/* Search Bar */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="mb-6"
      >


        <div className="flex gap-5 items-center pr-[15px] ">


          {/* <button
          className="px-4 py-2 mt-8 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg border border-gray-300 text-sm font-medium transition flex items-center space-x-2"
          onClick={() => setIsFilterDropdownOpen(!isFilterDropdownOpen)}
        >
          <MdFilterList className="text-xl" />
          <span>Filters</span>
        </button> */}


          {/* filter button */}
          <div className="relative">
            <button
              className="px-4 py-2 mt-6 h-10 shadow-lg bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg border border-gray-300 text-sm font-medium transition flex items-center space-x-2"
              onClick={() => setIsFilterDropdownOpen(!isFilterDropdownOpen)}
            >
              <MdFilterList className="text-xl" />
              <span>Filters</span>
            </button>
            {isFilterDropdownOpen && (
              <div
                ref={filterDropdownRef}
                className="absolute mt-2 bg-white border border-gray-300 rounded-xl shadow-lg w-48 z-10"
              >
                <div className="p-4">
                  <h3 className="text-lg font-semibold mb-2">Sentiment</h3>
                  {sentiments.map((sentiment) => (
                    <label key={sentiment} className="flex items-center space-x-2 mb-1">
                      <input
                        type="checkbox"
                        checked={selectedSentiments.includes(sentiment)}
                        onChange={() => {
                          if (selectedSentiments.includes(sentiment)) {
                            setSelectedSentiments(selectedSentiments.filter((s) => s !== sentiment));
                          } else {
                            setSelectedSentiments([...selectedSentiments, sentiment]);
                          }
                        }}
                      />
                      <span>{sentiment}</span>
                    </label>
                  ))}
                </div>
              </div>
            )}
          </div>


          {/* calender */}
          <div className="relative">
            {/* Date Picker Button */}
            <button className="px-4 py-2 mt-6 h-10 shadow-lg bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg border border-gray-300 text-sm font-medium transition flex items-center space-x-2"
              onClick={() => setIsOpen(!isOpen)}
              type="button"
              aria-haspopup="dialog"
              aria-expanded={isOpen}
            >
              <span>{formattedDateRange}</span>
            </button>

            {/* Date Picker Dropdown */}
            {isOpen && (
              <div className="absolute left-0 mt-2 bg-white border border-gray-300 rounded-lg shadow-lg z-10 p-6"
                ref={datePickerRef}>
                <DatePicker
                  selected={tempStart}
                  onChange={(dates) => {
                    const [start, end] = dates || [null, null];
                    setTempStart(start);
                    setTempEnd(end);
                  }}
                  startDate={tempStart}
                  endDate={tempEnd}
                  selectsRange
                  monthsShown={2} // Shows two months side by side
                  inline
                  fixedHeight
                  calendarClassName="custom-calendar"
                />

                {/* Apply Button */}
                <div className="flex justify-end mt-3">
                  <button
                    onClick={applyDateRange}
                    className="px-4 py-2 bg-[#60a5fa] text-white rounded-md transition"
                  >
                    Apply
                  </button>
                </div>
              </div>
            )}
          </div>

          <div className="flex flex-col  ">
            <label className="text-black ml-3 font-semibold mb-1">Search</label>
            <input
              type="text"
              placeholder="Search by From or To"
              className="w-full h-10 md:w-54 px-4 mb-1 bg-gray-100 border border-gray-300 rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>





          <div className="relative flex flex-col">
            <label className="text-gray-700 ml-2  font-semibold mb-1">Select Clients</label>
            <div
              className="w-full h-10 mb-1 md:w-44 px-1 py-3 border bg-gray-100 border-gray-300 rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500 cursor-pointer flex justify-between items-center"
              onClick={() => setUserDropdownOpen(!userDropdownOpen)}
            >
              {selectedUserId ? getUserNameById(selectedUserId) : "All Clients"}
              <svg
                className={`w-4 h-4 transform transition-transform ${userDropdownOpen ? "rotate-180" : ""}`}
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path d="M19 9l-7 7-7-7" />
              </svg>
            </div>
            {userDropdownOpen && (
              <div className="absolute top-16 mt-2 bg-white border border-gray-300 rounded-xl shadow-lg w-48 z-10">
                <div
                  className="p-2 hover:bg-blue-100 cursor-pointer"
                  onClick={() => {
                    setSelectedUserId("");
                    setUserDropdownOpen(false);
                  }}
                >
                  All Clients
                </div>
                {users
                  .filter((u) => u.name.toLowerCase() !== "admin") // Exclude "Admin"
                  .map((u) => (
                    <div
                      key={u._id || u.id}
                      className="p-2 hover:bg-blue-100 cursor-pointer"
                      onClick={() => {
                        setSelectedUserId(u._id || u.id);
                        setUserDropdownOpen(false);
                      }}
                    >
                      {u.name}
                    </div>
                  ))}
              </div>
            )}
          </div>






          {/* <div className="flex flex-col">
            <label className="text-gray-700 font-semibold mb-1">From Date</label>
            <input
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              className="w-full md:w-54 px-4 py-3 border border-gray-300 rounded-xl shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div className="flex flex-col">
            <label className="text-gray-700 font-semibold mb-1">To Date</label>
            <input
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              className="w-full md:w-54 px-4 py-3 border border-gray-300 rounded-xl shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div> */}




          <button
            className="p-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-full mt-6 border-gray-300"
            onClick={handleRefresh}
            title="Refresh Call History"
            disabled={loading}
          >
            <MdRefresh className={`text-2xl ${loading ? "animate-spin" : ""}`} />
          </button>

          <div className="flex justify-end mt-6 ml-auto space-x-4 ">
            <button
              className="px-6 py-2 h-auto w-auto text-black border border-black shadow-md rounded-lg focus:outline-none"
              onClick={exportToCSV}
            >
              Export to CSV
            </button>
            <button
              className="px-6 py-2 h-auto w-auto shadow-md text-black rounded-lg border border-black focus:outline-none"
              onClick={exportToXLSX}
            >
              Export to XLSX
            </button>
          </div>

        </div>
      </motion.div>

      {/* Loading and Error States */}
      {loading && (
        <motion.div
          className="flex justify-center items-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <div className="animate-spin w-8 h-8 border-4 border-t-4 border-blue-400 rounded-full"></div>
        </motion.div>
      )}
      {error && (
        <motion.p
          className="text-red-500"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          {error}
        </motion.p>
      )}

      {/* Call History Table */}
      {!loading && !error && (
        <motion.div
          className="overflow-x-auto bg-white shadow-lg rounded-lg"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-md">
            <thead className="sticky top-0 bg-blue-400 text-white">
              <tr>
                <th className="py-3 px-3 text-center border-b">ID</th>
                <th className="py-3 px-3 text-center border-b">From</th>
                <th className="py-3 px-3 text-center border-b">To</th>
                <th className="py-3 px-3 text-center border-b">Client Name</th>
                <th className="py-3 px-3 text-center border-b">Date</th>
                <th className="py-3 px-3 text-center border-b">Start Time</th>
                <th className="py-3 px-3 text-center border-b">End Time</th>
                <th className="py-3 px-3 text-center border-b">Sentiment Status</th>
                <th className="py-3 px-3 text-center border-b">Updated Status</th>
                <th className="py-3 px-3 text-center border-b">Updated Comments</th>
                <th className="py-3 px-3 text-center border-b">Summary</th>
              </tr>
            </thead>
            <tbody>
              {currentRecords.length > 0 ? (
                currentRecords.map((call, index) => (
                  <motion.tr
                    key={call._id}
                    className="hover:bg-gray-100 even:bg-gray-50 transition-all duration-200 ease-in-out transform"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.3 }}
                  >
                    <td className="py-3 px-3 border-b text-center">
                      {indexOfFirstRecord + index + 1}
                    </td>
                    <td className="py-3 px-3 border-b text-center">
                      {call.from}
                    </td>
                    <td className="py-3 px-3 border-b text-center">{call.to}</td>
                    <td className="py-3 px-3 border-b text-center">{getUserNameById(call.userId)}</td>
                    <td className="py-3 px-3 border-b text-center">
                      {formatDateToDDMMYYYY(call.createdAt)}
                    </td>
                    <td className="py-3 px-3 border-b text-center">
                      {call.startTime || "00:00:00"}
                    </td>
                    <td className="py-3 px-3 border-b text-center">
                      {call.endTime || "00:00:00"}
                    </td>
                    <td className="py-3 px-4 border-b text-center">
                      <span
                        className={`px-3 py-1 rounded-lg text-sm ${call.agentSentiment === "Positive"
                          ? "bg-green-100 text-green-700"
                          : call.agentSentiment === "Negative"
                            ? "bg-red-100 text-orange-700"
                            : call.agentSentiment === "Negative/DND"
                              ? "bg-red-100 text-red-700"
                              : call.agentSentiment === "Neutral"
                                ? "bg-yellow-100 text-yellow-700"
                                : "bg-blue-100 text-blue-700"
                          }`}
                      >
                        {call.agentSentiment ? call.agentSentiment
                          : "Not Attended"}
                      </span>
                    </td>
                    <td className="py-3 px-4 border-b text-center">
                      <span
                        className={`px-3 py-1 rounded-lg text-sm ${call.qaStatus === "Positive"
                          ? "bg-green-100 text-green-700"
                          : call.qaStatus === "Negative"
                            ? "bg-red-100 text-red-700"
                            : call.qaStatus === "Neutral"
                              ? "bg-yellow-100 text-yellow-700"
                              : ""
                          }`}
                      >
                        {call.qaStatus ? call.qaStatus : "N/A"}
                      </span>
                    </td>
                    <td className="py-3 px-3 border-b text-center">
                      <div className="max-h-20 overflow-y-auto">
                        {call.comments ? call.comments : "N/A"}
                      </div>
                    </td>
                    <td className="px-3 py-2 border-b text-center">
                      <button
                        className="px-3 py-2 bg-blue-400 text-white rounded-lg  focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition duration-200"
                        onClick={() => openSummaryPopup(call)}
                      >
                        View Summary
                      </button>
                    </td>
                  </motion.tr>
                ))
              ) : (
                <tr>
                  <td colSpan="10" className="py-3 px-3 text-center">
                    No records found for the selected date range.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </motion.div>
      )}
  {/* Pagination */}
{!loading && !error && filteredData.length > recordsPerPage && (
  <motion.div
    className="mt-6 flex justify-center"
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration: 0.5 }}
  >
    {/* Modified: Added responsive pagination with Previous/Next buttons and ellipsis */}
    <ul className="flex flex-wrap justify-center items-center space-x-2 md:space-x-3">
      {/* Previous Button */}
      <li>
        <button
          className={`px-4 py-2 rounded-xl text-white ${
            currentPage === 1 ? "bg-gray-300 cursor-not-allowed" : "bg-blue-400 hover:bg-blue-500"
          }`}
          onClick={() => paginate(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Previous
        </button>
      </li>

      {/* Pagination Logic with Limited Buttons */}
      {(() => {
        const totalPages = Math.ceil(filteredData.length / recordsPerPage);
        const maxVisibleButtons = 5; // Adjust this number based on design needs
        const halfVisible = Math.floor(maxVisibleButtons / 2);
        let startPage = Math.max(1, currentPage - halfVisible);
        let endPage = Math.min(totalPages, startPage + maxVisibleButtons - 1);

        // Adjust startPage if endPage is at the limit
        if (endPage - startPage + 1 < maxVisibleButtons) {
          startPage = Math.max(1, endPage - maxVisibleButtons + 1);
        }

        const pages = [];

        // Add first page and ellipsis if needed
        if (startPage > 1) {
          pages.push(
            <li key={1}>
              <button
                className={`px-4 py-2 rounded-xl text-white ${
                  currentPage === 1 ? "bg-blue-400 shadow-lg" : "bg-gray-300 hover:bg-blue-400"
                }`}
                onClick={() => paginate(1)}
              >
                1
              </button>
            </li>
          );
          if (startPage > 2) {
            pages.push(
              <li key="start-ellipsis" className="px-4 py-2">
                ...
              </li>
            );
          }
        }

        // Add visible page buttons
        for (let i = startPage; i <= endPage; i++) {
          pages.push(
            <li key={i}>
              <button
                className={`px-4 py-2 rounded-xl text-white ${
                  currentPage === i ? "bg-blue-400 shadow-lg" : "bg-gray-300 hover:bg-blue-400"
                }`}
                onClick={() => paginate(i)}
              >
                {i}
              </button>
            </li>
          );
        }

        // Add last page and ellipsis if needed
        if (endPage < totalPages) {
          if (endPage < totalPages - 1) {
            pages.push(
              <li key="end-ellipsis" className="px-4 py-2">
                ...
              </li>
            );
          }
          pages.push(
            <li key={totalPages}>
              <button
                className={`px-4 py-2 rounded-xl text-white ${
                  currentPage === totalPages ? "bg-blue-400 shadow-lg" : "bg-gray-300 hover:bg-blue-400"
                }`}
                onClick={() => paginate(totalPages)}
              >
                {totalPages}
              </button>
            </li>
          );
        }

        return pages;
      })()}

      {/* Next Button */}
      <li>
        <button
          className={`px-4 py-2 rounded-xl text-white ${
            currentPage === Math.ceil(filteredData.length / recordsPerPage)
              ? "bg-gray-300 cursor-not-allowed"
              : "bg-blue-400 hover:bg-blue-500"
          }`}
          onClick={() => paginate(currentPage + 1)}
          disabled={currentPage === Math.ceil(filteredData.length / recordsPerPage)}
        >
          Next
        </button>
      </li>
    </ul>
  </motion.div>
)}
      {/* Popup */}
      {isPopupOpen && selectedCall && (
        <div className="fixed inset-0 bg-gray-900 bg-opacity-80 flex justify-center items-center z-50">
          <motion.div
            className="bg-white/80 backdrop-blur-lg p-10 rounded-3xl w-11/12 max-w-4xl shadow-3xl relative flex flex-col md:grid md:grid-cols-2 gap-10 border border-gray-200"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
          >
            {/* Close Icon */}
            <button
              className="absolute top-6 right-6 text-gray-500 hover:text-red-600 transition-all duration-300"
              onClick={closePopup}
              aria-label="Close popup"
            >
              <MdClose className="text-3xl" />
            </button>

            {/* Left Panel */}
            <div className="flex flex-col gap-8">
              <h2 className="text-4xl font-extrabold text-gray-800 tracking-wide">
                Validate<br />Sentiment
              </h2>
              <div className="relative">
                <div
                  className="bg-gradient-to-br from-gray-50 to-gray-100 border border-gray-300 rounded-2xl p-4 text-lg text-gray-700 cursor-pointer flex justify-between items-center shadow-lg hover:shadow-xl transition-all"
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                >
                  {selectedSentiment || "Choose sentiment"}
                  <svg
                    className={`w-6 h-6 transform transition-transform ${dropdownOpen ? "rotate-180" : ""
                      }`}
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                  >
                    <path d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
                {dropdownOpen && (
                  <div className="absolute mt-2 bg-white/90 border border-gray-300 rounded-xl shadow-lg w-full z-10 overflow-hidden backdrop-blur-md">
                    {["Positive", "Neutral", "Negative", "Negative/DND"].map((option) => (
                      <div
                        key={option}
                        className="p-4 hover:bg-gradient-to-r from-blue-50 to-blue-100 text-gray-800 cursor-pointer transition-all duration-300"
                        onClick={() => {
                          setSelectedSentiment(option);
                          setDropdownOpen(false);
                        }}
                      >
                        {option}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              {/* Comment Input */}
              <div>
                <h2 className="text-lg font-semibold text-gray-700">
                  Leave a Comment
                </h2>
                <textarea
                  className="mt-2 p-4 w-full h-24 border border-gray-300 rounded-2xl bg-gray-50 text-gray-700 text-lg leading-relaxed shadow-inner focus:ring-2 focus:ring-blue-500 focus:outline-none resize-none"
                  placeholder="Write your comment here..."
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                />
              </div>
              <button
                className={`px-6 py-2 w-40 text-lg font-semibold rounded-full transition-all duration-300 ${updating
                  ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                  : "bg-blue-400 text-white hover:bg-blue-600"
                  }`}
                onClick={handleUpdate}
                disabled={updating}
              >
                {updating ? "Updating..." : "Update"}
              </button>

              {/* Audio Player */}
              <div>
                <h2 className="text-4xl font-extrabold text-gray-800 tracking-wide">
                  Call Recording
                </h2>
                {selectedCall && selectedCall.recordingUrl ? (
                  <audio
                    className="w-full mt-4 rounded-full border border-gray-300 shadow-md"
                    controls
                    src={selectedCall.recordingUrl}
                  >
                    Your browser does not support the audio element.
                  </audio>
                ) : (
                  <p className="text-gray-600 mt-2">No recording available.</p>
                )}
              </div>
            </div>

            {/* Right Panel */}
            <div className="flex flex-col gap-6">
              <h2 className="text-4xl font-extrabold text-gray-800 tracking-wide">
                Transcription
              </h2>




              <div className="flex-grow p-6 border border-gray-300 rounded-2xl bg-gray-50/80 text-gray-700 text-lg leading-relaxed overflow-auto max-h-96 shadow-inner">
                {/* {selectedCall.summary || "No summary available."} */}
                {selectedCall.diarization && selectedCall.diarization.length > 0 ? (
                  <ul className="mt-2">
                    {selectedCall.diarization.map((entry, index) => (
                      <li key={index} className="text-gray-600">
                        <strong>{entry.speaker}:</strong> {entry.text || "No speech"}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="text-gray-500 mt-2">No diarization details available.</p>
                )}
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </div>
  );
};

export default CallHistory;